import { blImageUrl, type ItemType } from '@brickloop/core/schemas';
import { useState } from 'react';
import { cn } from '../ui';

/** BrickLink's picture of an item in a colour. Falls back to a plain tile if there isn't one. */
export function ItemImage({
  itemType,
  itemNo,
  colorId,
  className,
  eager = false,
}: {
  itemType: ItemType;
  itemNo: string;
  colorId: number;
  className?: string;
  /** Print documents must load every image before the browser creates the PDF. */
  eager?: boolean;
}) {
  const [failed, setFailed] = useState(false);
  // A size in className replaces the default one rather than fighting it.
  const box = cn(!/(^|\s)size-/.test(className ?? '') && 'size-10', !/(^|\s)bg-/.test(className ?? '') && 'bg-slate-100', 'shrink-0 rounded object-contain', className);
  if (failed) {
    return (
      <div className={cn(box, 'flex items-center justify-center text-[10px] text-slate-400')} aria-hidden="true">
        no pic
      </div>
    );
  }
  return (
    <img
      src={blImageUrl(itemType, itemNo, colorId)}
      alt=""
      loading={eager ? 'eager' : 'lazy'}
      referrerPolicy="no-referrer"
      className={box}
      onError={() => setFailed(true)}
    />
  );
}

export function ColorSwatch({ rgb, name }: { rgb: string | null; name: string }) {
  return (
    <span className="inline-flex items-center gap-1.5">
      <span
        className="size-3.5 shrink-0 rounded-full ring-1 ring-slate-300"
        style={{ background: rgb ? `#${rgb}` : 'repeating-linear-gradient(45deg,#e2e8f0,#e2e8f0 3px,#fff 3px,#fff 6px)' }}
        aria-hidden="true"
      />
      {name}
    </span>
  );
}
